module.exports = __webpack_public_path__ + "img/video-icon.5c770f93.svg";